import React from 'react'
import { useLocale } from '../contexts/LocaleContext'

const LOCALES: { code: 'nl' | 'en'; label: string }[] = [
  { code: 'nl', label: 'NL' },
  { code: 'en', label: 'EN' },
]

/** Two letters and a slash, as the design draws it. No flags: language is not a country. */
const LanguageSwitcher: React.FC = () => {
  const { locale, setLocale } = useLocale()

  return (
    <span className="inline-flex items-center gap-1 text-sm font-medium">
      {LOCALES.map((entry, index) => (
        <React.Fragment key={entry.code}>
          {index > 0 && <span className="text-text-muted opacity-50">/</span>}
          <button
            type="button"
            lang={entry.code}
            aria-current={locale === entry.code ? 'true' : undefined}
            onClick={() => setLocale(entry.code)}
            className={
              locale === entry.code
                ? 'font-semibold text-text-primary'
                : 'text-text-muted hover:text-text-secondary'
            }
          >
            {entry.label}
          </button>
        </React.Fragment>
      ))}
    </span>
  )
}

export default LanguageSwitcher
